import { UIHeading2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './CallUnderDescriptionBannerRedesigned.css';

interface ICallUnderDescriptionBannerRedesignedProps {
  title?: string;
  fullWidth?: boolean;
  isOneLine?: boolean;
  agentAvatar?: React.ReactNode;
  addedStyles?: 'with-avatar' | 'without-avatar';
}

export function CallUnderDescriptionBannerRedesigned({
  children,
  ...textProps
}: React.PropsWithChildren<ICallUnderDescriptionBannerRedesignedProps>) {
  const { title = 'Позвоните автору', fullWidth, isOneLine, agentAvatar, addedStyles } = textProps;

  return (
    <div
      className={cx(
        styles['container'],
        fullWidth && styles['container-full-width'],
        isOneLine && styles['container-one-line'],
        addedStyles && styles[`container--${addedStyles}`],
      )}
    >
      <div className={styles['title']}>
        {agentAvatar}
        <UIHeading2>{title}</UIHeading2>
      </div>
      <div className={styles['content']}>{children}</div>
    </div>
  );
}
